import { render } from "./DrawMultipleFromDiscardIcon.vue?vue&type=template&id=12397a5a"
import script from "./DrawMultipleFromDiscardIcon.vue?vue&type=script&lang=js"
export * from "./DrawMultipleFromDiscardIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__